import {
	fetchReservationTimeAll,
	insertUserReservationWaiting,
	fetchUserReservationSummary,
	fetchReservationCode,
	fetchUserReservationWaitingList,
	cancelUserReservationWaiting,
} from '@/api';

const reservationAppStore = {
	namespaced: true,
	state: {
		labels: {
			step1: '',
			step2: '',
			step3: '',
			step4: '',
			step5: '',
		},
		isOpenContents: {
			step1: true,
			step2: false,
			step3: false,
			step4: false,
			step5: false,
		},
		isDisabled: {
			step1: false,
			step2: true,
			step3: true,
			step4: true,
			step5: true,
		},
		result: {
			branchName: '',
			reservationDate: '',
			reservationTime: '',
			reservationService: '',
		},
		reservationTime: [],
		userReservationStateList: [],
		reservationServiceCodeList: [],
		userReservationWaitingList: [],
	},
	getters: {
		reservationResult(state) {
			return state.result;
		},
		userReservationStateList(state) {
			return state.userReservationStateList;
		},
		reservationServiceCodeList(state) {
			return state.reservationServiceCodeList;
		},
		userReservationWaitingList(state) {
			return state.userReservationWaitingList;
		},
	},
	mutations: {
		setResult(state, data) {
			state.result = data;
		},
		getReservationTimeAll(state, list) {
			if (list === undefined) return;
			state.reservationTime = list;
		},
		setUserReservationStateList(state, list) {
			state.userReservationStateList = list || [];
		},
		setReservationServiceCodeList(state, list) {
			state.reservationServiceCodeList = list || [];
		},
		getUserReservationWaitingList(state, { page, list }) {
			if (page === undefined || list === undefined) return;

			page === 1
				? (state.userReservationWaitingList = [...list])
				: (state.userReservationWaitingList = [
						...state.userReservationWaitingList,
						...list,
				  ]);
		},
		initUserReservationWaitingList(state) {
			state.userReservationWaitingList = [];
		},
	},
	actions: {
		getReservationTimeAll({ commit }, payload) {
			return fetchReservationTimeAll(payload)
				.then(response => {
					commit('getReservationTimeAll', response.list);
					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		insertReservationWaiting({ commit }, payload) {
			return insertUserReservationWaiting(payload)
				.then(response => {
					if (response.data.code === '00000') {
						commit('initUserReservationWaitingList');
					}

					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		getUserReservationStateList({ commit }, payload) {
			return fetchUserReservationSummary(payload)
				.then(response => {
					commit('setUserReservationStateList', response.data.list);
					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		getReservationServiceCodeList({ commit }) {
			return fetchReservationCode()
				.then(response => {
					commit('setReservationServiceCodeList', response.data);
					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		getUserReservationWaitingList({ commit }, payload) {
			return fetchUserReservationWaitingList(payload)
				.then(response => {
					commit('getUserReservationWaitingList', response.data);
					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		cancelUserReservationWaiting(context, payload) {
			return cancelUserReservationWaiting(payload)
				.then(response => {
					return response;
				})
				.catch(error => {
					console.log(error);
					return error;
				});
		},
		initUserReservationWaitingList({ commit }) {
			commit('initUserReservationWaitingList');
		},
	},
};

export default reservationAppStore;
